module.exports = __webpack_public_path__ + "img/3.d29320e4.png";